/* 🤖 this file was generated by svg-to-ts */
export var GtdFlagLc = {
    name: 'lc',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><g fill-rule=\"evenodd\"><path fill=\"#65cfff\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"m254.8 44.8 173.5 421.6-344 1L254.7 44.8z\"/><path d=\"m255 103 150 362.6-297.5.8L255 103z\"/><path fill=\"#ffce00\" d=\"m254.8 256.1 173.5 210.8-344 .5 170.5-211.3z\"/></g></svg>"
};
